import React from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import ScrollTopButton from './components/ScrollTopButton/ScrollTopButton';

const Layout = () => {
    return (
        <div className="app-container">
            <Navbar />
            <main>
                <Outlet />
            </main>
            <Footer />
            <ScrollTopButton />
        </div>
    );
};

export default Layout;
